// extracted by mini-css-extract-plugin
module.exports = {"section":"VideoSection_section__CwffA"};